/**
 * Calendar RPC Definitions
 */

import { Rpc, RpcGroup } from "effect/rpc";
import { Schema } from "effect";
import {
  ListCalendarsRequestSchema,
  ListCalendarsResponseSchema,
  FindCalendarRequestSchema,
  FindCalendarResponseSchema,
} from "../schemas/calendar/index";
import { ExternalAPIErrorSchema, NotFoundErrorSchema } from "../errors";

export class CalendarRpcs extends RpcGroup.make(
  Rpc.make("CalendarList", {
    success: ListCalendarsResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: ListCalendarsRequestSchema,
  }),
  Rpc.make("CalendarFind", {
    success: FindCalendarResponseSchema,
    error: Schema.Union([ExternalAPIErrorSchema, NotFoundErrorSchema]),
    payload: FindCalendarRequestSchema,
  })
) {}
